



































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import StepMixin from '@mixin/step';
import StoreFileMixin from '@mixin/storeFile';
import ErrorResponseMixin from '@mixin/errorResponse';
import axios from 'axios';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            maxFiles: 5,
            post: {
                files: [],
                owner: 'project',
                type: 'offerte',
            },
        }
    },
    
    mixins: [
        StepMixin,
        StoreFileMixin,
        ErrorResponseMixin
    ],

    created() {
        this.post.id  = this.current.id;
        this.prepareStoringFiles(this.post);
    },

    methods: {
        async onNext() {
            return await this.storeFiles(this.post)
        },

        clearFile(index) {
            this.removeFile(this.files[index]);
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Offertes extends Vue {}

